"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _searchfield = require("@react-aria/searchfield");
var _searchfield2 = require("@react-stately/searchfield");
var _Icon = require("../../media/icon/Icon");
var _InnerButton = require("../../controls/buttons/InnerButton");
var _Button = require("../../controls/buttons/Button");
var _SearchField = require("./SearchField.styled");
var _useSetFocus = require("../../../hooks/useSetFocus");
var _focus = require("@react-aria/focus");
var _input = require("./../input/input.tokens");
var _input2 = require("../input/input.tokens");
var _jsxRuntime = require("react/jsx-runtime");
var SearchField = function SearchField(_ref) {
  var size = _ref.size,
    emphasis = _ref.emphasis,
    isExpandable = _ref.isExpandable,
    width = _ref.width,
    onSubmit = _ref.onSubmit,
    defaultValue = _ref.defaultValue,
    value = _ref.value,
    onChange = _ref.onChange,
    isDisabled = _ref.isDisabled,
    placeholder = _ref.placeholder,
    id = _ref.id,
    dataCy = _ref['data-cy'];
  var ariaProps = {
    onSubmit: onSubmit,
    onChange: onChange,
    defaultValue: defaultValue,
    value: value,
    isDisabled: isDisabled
  };
  var state = (0, _searchfield2.useSearchFieldState)(ariaProps);
  var _ref2 = (0, _react.useState)(!isExpandable),
    _ref3 = _slicedToArray(_ref2, 2),
    showInputField = _ref3[0],
    setShowInputField = _ref3[1];
  var _ref4 = (0, _useSetFocus.useSetFocus)(),
    _ref5 = _slicedToArray(_ref4, 2),
    inputRef = _ref5[0],
    setInputFocus = _ref5[1];
  (0, _react.useEffect)(function () {
    if (showInputField) {
      setInputFocus();
    }
  }, [setInputFocus, showInputField]);
  var showInput = (0, _react.useMemo)(function () {
    return !isExpandable || state.value !== '';
  }, [isExpandable, state.value]);
  (0, _react.useEffect)(function () {
    if (showInput) {
      setShowInputField(true);
    }
  }, [showInput]);

  // get react-aria logic
  // note that normally we would just pass all clearButtonProps to the clear button,
  // but we want it to receive keyboard events and default react-aria prevents that
  // so we use the onPress event and call clearButtonProps.onPress ourselves
  var _ref6 = (0, _searchfield.useSearchField)(_objectSpread({}, ariaProps, {
      'aria-label': 'search'
    }), state, inputRef),
    inputProps = _ref6.inputProps,
    clearButtonProps = _ref6.clearButtonProps;
  function clearInputField() {
    clearButtonProps.onPress(undefined);
    setInputFocus();
  }
  function toogleInputField() {
    if (isExpandable) {
      setShowInputField(!showInputField);
    }
  }
  var hideInputIfEmpty = function hideInputIfEmpty() {
    if (isExpandable) {
      setShowInputField(state.value !== '');
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_SearchField.SearchFieldWrapper, {
    showInputField: showInputField,
    size: size,
    emphasis: emphasis,
    width: width,
    isDisabled: isDisabled,
    id: id,
    children: [showInputField && /*#__PURE__*/(0, _jsxRuntime.jsx)(_focus.FocusRing, {
      focusRingClass: 'focus-ring',
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("input", _objectSpread({
        width: '100%'
      }, inputProps, showInputField ? {} : {
        tabIndex: -1
      }, {
        ref: inputRef,
        placeholder: placeholder,
        "aria-label": 'search-input',
        onBlur: hideInputIfEmpty,
        "data-cy": dataCy
      }))
    }), state.value !== '' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerButton.InnerButton, {
      onPress: clearInputField,
      "aria-label": 'clear-search',
      width: _input.tokens.size.height[size],
      height: _input.tokens.size.height[size],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        icon: 'close',
        color: emphasis === _Button.EMPHASIS.HIGH ? 'default' : 'secondary'
      })
    }), state.value === '' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerButton.InnerButton, {
      onPressEnd: toogleInputField,
      excludeFromTabOrder: showInputField,
      preventFocusOnPress: true,
      "aria-label": 'toggle-search',
      onFocus: function onFocus() {
        setShowInputField(true);
      },
      width: _input.tokens.size.height[size],
      height: _input.tokens.size.height[size],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        icon: 'search'
      })
    })]
  });
};
SearchField.defaultProps = {
  emphasis: _Button.EMPHASIS.MEDIUM,
  isExpandable: true,
  width: '250px',
  size: _input2.TextFieldSize.LARGE,
  'data-cy': 'search-field'
};
SearchField.SIZE = _input2.TextFieldSize;
var _default = exports.default = SearchField;